var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRightTurn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(60, 60)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M -30 40 L -30 0 Q -30 -30, 0 -30 L 30 -30",
    stroke: "#2c3e50",
    strokeWidth: 12,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 30 -30 L 15 -45 M 30 -30 L 15 -15",
    stroke: "#2c3e50",
    strokeWidth: 12,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightTurn);
export default __webpack_public_path__ + "static/media/right-turn.6ee39ef4c9d7de9760f3ed6b956cc87d.svg";
export { ForwardRef as ReactComponent };